import { createSpreadableBem } from "/Helpers/createBem";
import "./InfobotAITeaser.scss";
import {
  OptimizelyEditProperty,
  Button,
  IconLookup,
  HideFor,
} from "/App.Components";
import { ColorTheme } from "/Models/Models/ColorTheme";
import { InfobotAITeaserProps } from "/Models/Generated/InfobotAITeaserProps";

enum InfobotAITeaserTheme {
  Default = 1,
  Hero = 2,
}

interface Props extends InfobotAITeaserProps {
  theme?: InfobotAITeaserTheme;
  mediumButtonOnMobile?: boolean;
}

const InfobotAITeaser = ({
  texts,
  textsPropertyName,
  ctaIcon,
  ctaLink,
  ctaLinkPropertyName,
  mediumButtonOnMobile,
  theme = InfobotAITeaserTheme.Default,
}: Props) => {
  const bem = createSpreadableBem("infobot-ai-teaser");

  return (
    <div
      {...bem("", {
        "--theme-hero": theme === InfobotAITeaserTheme.Hero,
      })}
    >
      <OptimizelyEditProperty propertyName={textsPropertyName}>
        {texts?.map((text, idx) => (
          <p {...bem("__text")} key={idx}>
            {text}
          </p>
        ))}
      </OptimizelyEditProperty>
      <OptimizelyEditProperty propertyName={ctaLinkPropertyName}>
        {ctaLink?.text && (
          <div {...bem("__button-container")}>
            <HideFor mobile tablet>
              <Button
                iconBefore={
                  ctaIcon && (
                    <IconLookup
                      iconType={ctaIcon}
                      iconProps={{
                        thickness: "Reg",
                        size: "32",
                        color: ColorTheme.black,
                      }}
                    />
                  )
                }
                size="l"
                style={"primary"}
                label={ctaLink.text}
                href={ctaLink.href}
              />
            </HideFor>
            <HideFor desktop desktopMedium desktopLargeUp>
              <Button
                iconBefore={
                  ctaIcon && (
                    <IconLookup
                      iconType={ctaIcon}
                      iconProps={{
                        thickness: "Reg",
                        size: mediumButtonOnMobile ? "24" : "32",
                        color: ColorTheme.black,
                      }}
                    />
                  )
                }
                size={mediumButtonOnMobile ? "m" : "l"}
                style={"primary"}
                label={ctaLink.text}
                href={ctaLink.href}
              />
            </HideFor>
          </div>
        )}
      </OptimizelyEditProperty>
    </div>
  );
};

InfobotAITeaser.Theme = InfobotAITeaserTheme;

export default InfobotAITeaser;
